import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';
import { CommonMap } from 'client/tracking/maps/common';
import { TrackingMap as CarBuyingMap } from 'client/tracking/maps/car-buying/search-by-payment-type';
import { CompareVehicleTrayMap } from 'client/tracking/maps/common/compare-vehicle-tray';
import { SuggestedVehiclePricingCarouselMap } from 'site-modules/shared/components/suggested-vehicle-pricing-carousel/tracking';
import { HomepageAdExtensionMap } from 'client/tracking/maps/common/homepage-ad-extension';

export const map = {
  read_more_how_we_rank: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_RESET_NAVIGATION,
    TrackingConstant.NAVIGATE_EXPAND
  ),
  view_more_info: TrackingEvent.actionCompleted(TrackingConstant.ACTION_VIEW_CONTENT, TrackingConstant.VIEW_MORE_INFO, {
    action_cause: 'image_click',
    value: 'view_subcategory_info',
  }),
  view_not_yet_rated_info: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.VIEW_MORE_INFO,
    {
      action_cause: 'image_click',
      value: 'not_yet_rated_info',
    }
  ),
  view_not_yet_rated_model: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_MMY_SELECT,
    TrackingConstant.SELECT_MAKE_MODEL,
    {
      value: 'not_yet_rated_model',
    }
  ),
  view_article: TrackingEvent.actionCompleted(TrackingConstant.ACTION_VIEW_CONTENT, 'view_article'),
  subtype_list_expand: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_RESET_NAVIGATION,
    TrackingConstant.NAVIGATE_EXPAND,
    {
      value: 'see_remaining_list',
    }
  ),
  subtype_list_collapse: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_RESET_NAVIGATION,
    TrackingConstant.NAVIGATE_COLLAPSE,
    {
      value: 'hide_remaining_list',
    }
  ),
  veh_card_core_page_nav: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_MMY_SELECT,
    TrackingConstant.SELECT_MAKE_MODEL
  ),
  veh_card_srp_nav: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_INVENTORY_SELECT,
    TrackingConstant.SELECT_MAKE_MODEL
  ),
  type_anchor_nav_link: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.JUMP_TO_SUBCATEGORY_CONTENT
  ),
  make_type_select: TrackingEvent.actionCompleted(TrackingConstant.ACTION_MMY_SELECT, TrackingConstant.MAKE_SELECT),

  view_hidden_gems_lease_deals: TrackingEvent.actionCompleted(TrackingConstant.VIEW_PRICING_DETAILS, 'oem_lease_deal'),
};

export const TrackingMap = {
  ...CommonMap,
  ...CarBuyingMap,
  ...CompareVehicleTrayMap,
  ...map,
  ...SuggestedVehiclePricingCarouselMap,
  ...HomepageAdExtensionMap,
};
